import DishDetailsModal from "./DishDetailsModal";
import DishDetailsModalTrigger from "./DishDetailsModalTrigger";

export default DishDetailsModal;

export {DishDetailsModalTrigger};
